import { Button } from "components/ui/button";
import { Color } from "utils/theme";
import { UsbTransferStates } from "./usb-transfer-modal";
import { Trans, useTranslation } from "react-i18next";
import { Download } from "lucide-react";

export const StartState = ({ setScreenState, fetch, onClose }) => {
  const { t } = useTranslation();

  return (
    <section className="">
      <p className="text-base mb-4 max-w-md" style={{ color: Color.White }}>
        <Trans
          i18nKey={
            "settings.general_settings.usb_data_transfer.start_modal.description"
          }
        >
          Transfer offline collected trip data to a connected USB drive. Make
          sure you have connected a USB drive to the IMAS Control unit.
        </Trans>
      </p>

      <span className="flex flex-col-reverse sm:flex-row">
        <Button
          onClick={onClose}
          className="flex-1 mt-2 sm:mt-0 sm:mr-3"
          variant="secondary"
        >
          {t("common.cancel")}
        </Button>
        <Button
          className="flex-1"
          onClick={() => {
            setScreenState(UsbTransferStates.Transfer);
            fetch();
          }}
        >
          <Download className="w-5 h-5 mr-2" />
          {t("settings.general_settings.usb_data_transfer.button")}
        </Button>
      </span>
    </section>
  );
};
